"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const recoil_1 = require("recoil");
const companyInfoState_1 = __importDefault(require("./companyInfoState"));
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const material_ui_confirm_1 = require("material-ui-confirm");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1({ open, closeDialog, switchToQna, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    const [companyInfo, setCompanyInfo] = (0, recoil_1.useRecoilState)(companyInfoState_1.default);
    const resetCompanyInfo = (0, recoil_1.useResetRecoilState)(companyInfoState_1.default);
    const dispatch = (0, react_redux_1.useDispatch)();
    const onLeaderDisagreeError = () => {
        resetCompanyInfo();
        dispatch((0, roomViewStore_1.invalidateCompanyInfo)());
        closeDialog();
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onRecaptchaChange = (token) => __awaiter(this, void 0, void 0, function* () {
        if (!!token) {
            yield (0, _1.handleRecaptchaToken)({ token, setCompanyInfo, confirm, onLeaderDisagreeError });
        }
    });
    const onQnaClick = () => {
        closeDialog();
        switchToQna();
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-80)' } } }, PaperProps: {
            sx: {
                width: '480px',
                padding: '14px',
                borderRadius: '16px',
                margin: '0 20px',
            },
        } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '16px' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle1 gray-80", css: { alignSelf: 'center' } }, { children: t('사업자 정보') })), !!companyInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.CompanyInfo, { companyInfo: companyInfo, onQnaClick: onQnaClick }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 success-main" }, { children: t('판매자의 명시적 동의 없이 판매자 정보를 수집 및 활용하여 영리 목적 등으로 활용하는 경우 정보통신망법 등 관련 법령에 의거하여 과태료 부과 및 형사처벌의 대상이 될 수 있습니다.') }))] })) : ((0, jsx_runtime_1.jsx)(react_google_recaptcha_1.default, { css: { alignSelf: 'center' }, sitekey: process.env.RECAPTCHA_KEY, onChange: onRecaptchaChange })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                        width: '100%',
                        height: '40px',
                        padding: '0 16px',
                        borderRadius: '8px',
                        bgcolor: 'var(--primary-main) !important',
                        color: 'var(--white)',
                    }, onClick: closeDialog }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('확인') })) }))] })) })));
}
exports.default = default_1;
